import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { LegalContent } from "@/components/LegalContent";

export default function LegalPage({ slug }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { setDoc(null); api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setError(true)); }, [slug]);
  useEffect(() => { if (doc) document.title = `${doc.title} · BDC-Boutique`; }, [doc]);

  if (error) return <p className="py-32 text-center font-serif text-2xl" data-testid="legal-error">Pagina non disponibile.</p>;
  if (!doc) return <div className="max-w-3xl mx-auto px-5 pt-16"><div className="h-10 w-2/3 bg-[#E9DFCE] animate-pulse" /></div>;

  return (
    <article className="max-w-3xl mx-auto px-5 sm:px-8 pt-16" data-testid={`legal-page-${slug}`}>
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#956842] mb-3">Informazioni legali</div>
      <h1 data-testid="legal-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#39251D] leading-[1.02]">{doc.title}</h1>
      <p className="mt-4 text-xs text-[#242321]/55" data-testid="legal-version">
        Versione {doc.version} · aggiornata il {new Date(doc.updated_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}
      </p>
      {doc.incomplete && (
        <div data-testid="legal-incomplete-banner" className="mt-8 flex gap-3 p-4 border border-[#956842]/40 bg-[#956842]/8 text-sm">
          <AlertTriangle className="w-5 h-5 text-[#956842] shrink-0" />
          <p>Documento in fase di verifica: le parti evidenziate come <b>"Da verificare"</b> sono provvisorie e verranno confermate prima dell'apertura delle vendite.</p>
        </div>
      )}
      <LegalContent content={doc.content} />
    </article>
  );
}
